import './Row.scss';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link} from "react-router-dom";

function Row({ title, fetchUrl, isPoster }) { // Correction : destructurer les props
    const API_KEY = "eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJkNjBjNzQ5MWI1ODBiYTM5MTkxYmUxYmM1MTZkMmJlMiIsIm5iZiI6MTcxOTMxNzMxMS41ODI4NjksInN1YiI6IjY2N2FhZDk5ZDMxOTQ0ZDM3MDE1OTZhZCIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.FSfDtUpsYOy9O6iOozOgOM0PbmM_QJX9al_SxJdzI4w";

    const [movies, setMovies] = useState([]);

    useEffect(() => {
        async function fetchData() {
            try {
                const options = {
                    method: 'GET',
                    headers: {
                        accept: 'application/json',
                        Authorization: `Bearer ${API_KEY}`
                    }
                };
                const request = await axios.get(fetchUrl, options);
                console.log("detai :", request.data.results);
                setMovies(request.data.results);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        fetchData();
    }, [fetchUrl]);

    return (
        <div className="row">
            <h2 className='row__title'>{title}</h2> 
            <div className='row__images'>
                {movies.map((movie) => (
                    <div key={movie.id}>
                        {
                            isPoster ? (
                                
                            <Link to={`/video/${movie?.id}`}> 
                                <img 
                                    src={`https://image.tmdb.org/t/p/original/${movie.poster_path}`} 
                                    className='row__image' 
                                    alt={movie.title || movie.name} 
                                />
                            </Link>

                            ) : (
                                
                            <Link to={`/video/${movie?.id}`}> 
                                <img 
                                    src={`https://image.tmdb.org/t/p/original/${movie.backdrop_path}`} 
                                    className='row__image' 
                                    alt={movie.title || movie.name} 
                                />
                            </Link>
                            )
                        }
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Row;
